export enum AddressType {
  REGISTRATION = 'Registration',
  ACCOMMODATION = 'Accommodation',
}
